import * as React from "react";
import { inject, observer } from "mobx-react";
import { AppProps } from "../../stores/storeContract";
import { Redirect } from "react-router-dom";

@inject("userStore")
@observer
export default class Navigation extends React.Component<AppProps> {

	render() {

		const { redirectUrl } = this.props.userStore;
		
		if (redirectUrl) {
            var  tmpRedirectUrl = redirectUrl;
			return(<Redirect to={tmpRedirectUrl} />);
		}

        return(<div></div>);
	}
}